import { useCallback, useState } from 'react';
import { StudyIntake } from '../../models/StudyIntake';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useGetStudyIntake() {
  const [studyIntake, setStudyIntake] = useState<StudyIntake>();
  const { loading, error, getJson } = useHttpFetchApi();

  const getStudyIntake = useCallback(
    async (studyParticipantId: number) => {
      const studyIntake = await getJson<StudyIntake>(
        `study-participants/${studyParticipantId}/study-intake`
      );
      setStudyIntake(studyIntake);
      return studyIntake;
    },
    [getJson]
  );

  return {
    studyIntake,
    loadingStudyIntake: loading,
    loadingStudyIntakeError: error,
    getStudyIntake
  };
}
